import { gql } from '@apollo/client';

/**
 * Spec 0028 B — hiring interviews. Operation names deliberately differ from the
 * backend field names (`teacherInterviews`, `interviewZoomCandidates`, …) to
 * avoid the codegen result-type collapse.
 *
 * `source` / `status` / `transcriptSource` are plain lowercase Strings on the
 * wire, never graphene enums.
 */

export const TeacherInterviewsQuery = gql`
  query ErpTeacherInterviews($teacherId: ID!) {
    teacherInterviews(teacherId: $teacherId) {
      id
      teacherId
      source
      title
      recordedAt
      durationMinutes
      status
      errorMessage
      retryCount
      externalUrl
      hasVideo
      sizeBytes
      hasTranscript
      transcriptSource
      transcriptChars
      zoomRecordingId
      zoomTopic
      zoomAccountEmail
      createdAt
      createdByName
    }
  }
`;

/** The transcript body — separate because it is large and only the drawer needs it. */
export const TeacherInterviewTranscriptQuery = gql`
  query ErpTeacherInterviewTranscript($interviewId: ID!) {
    teacherInterviewTranscript(interviewId: $interviewId) {
      interviewId
      transcriptSource
      text
    }
  }
`;

/** Signed, short-lived and audited on every issue — never cached long. */
export const TeacherInterviewVideoUrlQuery = gql`
  query ErpTeacherInterviewVideoUrl($interviewId: ID!) {
    teacherInterviewVideoUrl(interviewId: $interviewId)
  }
`;

/**
 * The picker. A NARROW query in the teachers schema rather than
 * `allZoomRecordings`: that one is gated on ZOOM_ACCESS_ROLES (which excludes
 * HR and includes Methodist — the wrong set for a teacher card) and returns
 * `files: JSONString!` containing raw Zoom download URLs.
 */
export const InterviewZoomCandidatesQuery = gql`
  query ErpInterviewZoomCandidates(
    $dateFrom: Date
    $dateTo: Date
    $accountId: ID
    $search: String
  ) {
    interviewZoomCandidates(
      dateFrom: $dateFrom
      dateTo: $dateTo
      accountId: $accountId
      search: $search
    ) {
      id
      topic
      startTime
      durationMinutes
      totalSizeBytes
      accountId
      accountEmail
      hasVideo
      hasTranscript
      isAlreadyAttached
      retentionWarning
    }
  }
`;

export const InterviewZoomDefaultAccountQuery = gql`
  query ErpInterviewZoomDefaultAccount {
    interviewZoomDefaultAccountId
  }
`;
